import Select from "../../../../form/select/Select";

const TextAlignOptions = ({ editor }) => {
  const alignmentOptions = [
    { name: "Left Align", value: "left", icon: "fa fa-align-left" },
    { name: "Center Align", value: "center", icon: "fa fa-align-center" },
    { name: "Right Align", value: "right", icon: "fa fa-align-right" },
    { name: "Justify Align", value: "justify", icon: "fa fa-align-justify" },
  ];

  function getActiveAlignment() {
    return (
      ["left", "center", "right", "justify"].find((alignment) =>
        editor.isActive({ textAlign: alignment })
      ) || "left"
    );
  }

  function onChangeHandler(val) {
    editor.chain().focus().setTextAlign(val).run();
  }

  return (
    <div className="w-40">
      <Select
        dropdownData={alignmentOptions}
        selectedValue={getActiveAlignment()}
        onChange={onChangeHandler}
        checked={false}
      />
    </div>
  );
};

export default TextAlignOptions;
